import React, { useEffect, useContext } from "react"
import AuthContext from "context/auth/authContext"
import TemplateList from "./templateList"
import useTemplatesManager from "hooks/templates/useTemplatesManager"

const TemplatesContent = () => {
  const { fetchTemplates } = useTemplatesManager()
  const { user, getUser } = useContext(AuthContext)

  useEffect(() => {
    if (!user) {
      getUser()
    } else {
      fetchTemplates(user["custom:organizationId"], true)
    }
  }, [user])

  return <TemplateList />
}

export default TemplatesContent
